import { LockOutlined } from '@mui/icons-material';
import FlashOnIcon from '@mui/icons-material/FlashOn';
import UpdateIcon from '@mui/icons-material/Update';
import HourglassBottom from '@mui/icons-material/HourglassBottom';
import { Typography, useTheme } from '@mui/material';
import { UserNoPassword } from '../types';

interface Props {
  fontSize?: 'inherit' | 'large' | 'small';
  enabled?: boolean;
  lockUser?: null | undefined | UserNoPassword;
}

export const LiveIcon = ({ fontSize, enabled }: Props) => {
  const iconSize = fontSize ? fontSize : 'medium';
  const theme = useTheme();
  const enabledColor = theme.palette.mode === 'dark' ? 'yellow' : '#1976d2';

  if (enabled) {
    return <FlashOnIcon fontSize={iconSize} htmlColor={enabledColor} />;
  } else {
    return <FlashOnIcon fontSize={iconSize} color='disabled' />;
  }
};

export const PollingIcon = ({ fontSize, enabled }: Props) => {
  const iconSize = fontSize ? fontSize : 'medium';
  const theme = useTheme();
  const enabledColor = theme.palette.mode === 'dark' ? 'yellow' : '#1976d2';

  if (enabled) {
    return <UpdateIcon fontSize={iconSize} htmlColor={enabledColor} />;
  } else {
    return <UpdateIcon fontSize={iconSize} color='disabled' />;
  }
};

export const LockIcon = ({ fontSize, enabled, lockUser }: Props) => {
  const iconSize = fontSize ? fontSize : 'medium';
  const theme = useTheme();
  const enabledColor = theme.palette.mode === 'dark' ? 'yellow' : '#1976d2';
  return (
    <>
      <LockOutlined fontSize={iconSize} htmlColor={enabledColor} />
      {lockUser && <Typography variant='body2'>{lockUser.name}</Typography>}
    </>
  );
};

export const TimeshareIcon = ({ fontSize, enabled }: Props) => {
  const iconSize = fontSize ? fontSize : 'medium';
  const theme = useTheme();
  const enabledColor = theme.palette.mode === 'dark' ? 'yellow' : '#1976d2';

  if (enabled) {
    return <HourglassBottom fontSize={iconSize} htmlColor={enabledColor} />;
  } else {
    return <HourglassBottom fontSize={iconSize} color='disabled' />;
  }
};
